import React, { useCallback } from "react";
import ReactFlow, { useReactFlow, Panel } from "reactflow";
import Button from "../button/Button";
import {
  FaRegDotCircle,
  FaRegFileCode,
  FaPuzzlePiece,
  FaBeer,
  FaPlus,
  FaMinus,
  FaEye,
  FaSitemap,
  FaShapes,
  FaAngular,
  FaReact,
  FaVuejs,
  FaGitAlt,
  FaCss3Alt,
  FaFileContract,
  FaHome,
  FaLemon,
  FaBug,
  
} from "react-icons/fa";

const ZoomTransition = () => {
  const { setViewport, zoomIn, zoomOut } = useReactFlow();

  const handleTransform = useCallback(
    (x, y) => {
      setViewport({ x: x, y: y, zoom: 1 }, { duration: 1000 });
    },
    [setViewport]
  );

  return (
    <Panel position="top-left" className="opacity-[0.9] ">
      <ul className="menu text-xs bg-base-200 rounded-box gap-1">
        <li>
          <a
            onClick={() => zoomIn({ duration: 800 })}
            className=""
            data-tip="ZoumIn"
          >
            <FaPlus />
            In
          </a>
        </li>
        <li>
          <a
            onClick={() => zoomOut({ duration: 800 })}
            className=""
            data-tip="ZoomOut"
          >
            <FaMinus />
            Out
          </a>
        </li>
        <li>
          <a
            onClick={() => {
              handleTransform(-200, 500);
            }}
            className="text-xs bg-gray-200"
            data-tip="Home"
            id="home"
          >
            <FaHome />
            Home
          </a>
        </li>
        <li>
          <a
            onClick={() => {
              handleTransform(900, 50);
            }}
            className="text-xs bg-yellow-300"
            data-tip="Prog"
            id="prog"
          >
            <FaRegFileCode /> Prog
          </a>
        </li>
        <li>
          <a
            onClick={() => {
              handleTransform(-120, -200);
            }}
            className="text-xs bg-cyan-200"
            data-tip="Fram"
          >
            <FaPuzzlePiece />
            Fram
          </a>
        </li>
        <li>
          <a
            onClick={() => {
              handleTransform(400, -400);
            }}
            className="text-xs bg-cyan-400"
            data-tip="React"
          >
            <FaReact />
            React
          </a>
        </li>
        <li>
          <a
            onClick={() => {
              handleTransform(100, -500);
            }}
            className="text-xs bg-rose-600 "
            data-tip="Ang"
          >
            <FaAngular />
            Ang
          </a>
        </li>
        <li>
          <a
            onClick={() => {
              handleTransform(-400, -500);
            }}
            className="text-xs bg-teal-600  "
            data-tip="Vue"
          >
            <FaVuejs />
            Vue
          </a>
        </li>
        <li>
          <a
            onClick={() => {
              handleTransform(-650, -350);
            }}
            className="text-xs bg-red-500  "
            data-tip="Svelt"
          >
            <FaLemon />
            Svelt
          </a>
        </li>

        <li>
          <a
            onClick={() => {
              handleTransform(900, 800);
            }}
            className="text-xs bg-green-300"
            data-tip="Test"
          >
            <FaBug />
            Test
          </a>
        </li>
        <li>
          <a
            onClick={() => {
              handleTransform(400, 1200);
            }}
            className="text-xs bg-orange-400"
            data-tip="UI"
          >
            <FaShapes />
            UI
          </a>
        </li>
        <li>
          <a
            onClick={() => {
              handleTransform(-600, 1250);
            }}
            className="text-xs bg-emerald-400"
            data-tip="Craft"
          >
            <FaFileContract />
            Craft
          </a>
        </li>
        <li>
          <a
            onClick={() => {
              handleTransform(900, -600);
            }}
            className="text-xs bg-pink-400"
            data-tip="Style"
          >
            <FaCss3Alt />
            Style
          </a>
        </li>

        <li>
          <a
            onClick={() => {
              handleTransform(-1200, 800);
            }}
            className="text-xs bg-pink-600   "
            data-tip="UX"
          >
            <FaSitemap />
            UX
          </a>
        </li>
        <li>
          <a
            onClick={() => {
              handleTransform(-1200, 200);
            }}
            className="text-xs bg-lime-400"
            data-tip="Vers"
          >
            <FaGitAlt />
            Vers
          </a>
        </li>
      </ul>
    </Panel>
  );
};
export default ZoomTransition;
